// extracted by mini-css-extract-plugin
module.exports = {"content__subtitle":"styles_content__subtitle__JuMTp"};